/* eslint-disable no-undef */
if (window.__POWERED_BY_QIANKUN__ && process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line camelcase
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}
